import { get } from '../../../utils/api';

export default {
  getPage: params => get({ url: 'page/get', data: params }),
  getPageCompositeDetail: params => get({ url: 'page/composite-detail', data: params }),
};
